import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react';
import '../../../../scss/common/snackbar.scss';
import { observer } from 'mobx-react';
import { useRef } from 'react';
const Snackbar = observer( /*#__PURE__*/forwardRef((props, ref) => {
  let {
    className = '',
    text = '',
    actionButtonText = null,
    onClickActionButton = null,
    icon = null,
    iconColor = '#1C8576',
    defaultTimeMs = 5000,
    autoClose = false,
    closeOnAction = false
  } = props;
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [textToDisplay, setTextToDisplay] = useState(text);
  const snackbarRef = useRef(null);
  const hideAfterTime = time => {
    if (time !== -1) {
      setTimeout(() => {
        setShowSnackbar(false);
      }, time);
    }
  };
  const handleClickActionButton = () => {
    if (closeOnAction) {
      setShowSnackbar(false);
    }
    if (onClickActionButton) {
      onClickActionButton();
    }
  };

  // For click outside of snackbar
  useEffect(() => {
    document.addEventListener('mousedown', event => {
      if (snackbarRef.current && !snackbarRef.current.contains(event.target)) {
        setShowSnackbar(false);
      }
    });
  }, []);

  // per usarlo come riferimento
  useImperativeHandle(ref, () => ({
    showSnackbar: (textToShow = null, timeMs = -1) => {
      if (textToShow) {
        setTextToDisplay(textToShow);
      }
      setShowSnackbar(true);
      if (timeMs !== -1) {
        hideAfterTime(timeMs);
      } else if (autoClose) {
        hideAfterTime(defaultTimeMs);
      }
    },
    hideSnackbar: () => {
      setShowSnackbar(false);
    }
  }));
  return showSnackbar ? /*#__PURE__*/React.createElement("div", {
    ref: snackbarRef,
    className: `${className} cms-snackbar ${showSnackbar ? 'showing' : 'not-showing'}`
  }, icon !== null ? /*#__PURE__*/React.createElement("span", {
    style: {
      backgroundColor: `${iconColor}`
    },
    className: "icon-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: `icon ${icon} small`
  })) : null, /*#__PURE__*/React.createElement("span", {
    className: "text-container"
  }, Array.isArray(textToDisplay) ? textToDisplay.map(m => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, m), /*#__PURE__*/React.createElement("br", null));
  }) : textToDisplay), actionButtonText !== null ? /*#__PURE__*/React.createElement("span", {
    className: "action-button",
    onClick: () => handleClickActionButton()
  }, actionButtonText) : null) : null;
}));
export default Snackbar;